/**
 * Obtiene el label de una sucursal dado su refSucursal
 * @param {string} refSucursal - ID de la sucursal
 * @param {Array} sucursalesEmpleado - Array con datos completos de sucursales
 * @returns {string} - Label de la sucursal o refSucursal como fallback
 */
export const obtenerLabelSucursal = (refSucursal, sucursalesEmpleado = []) => {
  const sucursal = sucursalesEmpleado.find(
    (s) => s.refSucursal === refSucursal,
  );
  return sucursal?.label || refSucursal;
};

/**
 * Obtiene el refSucursal dado un label
 * @param {string} label - Label de la sucursal
 * @param {Array} sucursalesEmpleado - Array con datos completos de sucursales
 * @returns {string} - refSucursal o label como fallback
 */
export const obtenerRefSucursal = (label, sucursalesEmpleado = []) => {
  const sucursal = sucursalesEmpleado.find((s) => s.label === label);
  return sucursal?.refSucursal || label;
};

/**
 * Mapea un array de refSucursal a sus respectivos labels
 * @param {Array} refsSucursales - Array de refSucursal
 * @param {Array} sucursalesEmpleado - Array con datos completos de sucursales
 * @returns {Array} - Array de labels
 */
export const mapearSucursalesALabels = (
  refsSucursales,
  sucursalesEmpleado = [],
) => {
  return refsSucursales.map((ref) =>
    obtenerLabelSucursal(ref, sucursalesEmpleado),
  );
};

/**
 * Mapea un array de labels a sus respectivos refSucursal
 * @param {Array} labels - Array de labels
 * @param {Array} sucursalesEmpleado - Array con datos completos de sucursales
 * @returns {Array} - Array de refSucursal
 */
export const mapearLabelsASucursales = (labels, sucursalesEmpleado = []) => {
  return labels.map((label) => obtenerRefSucursal(label, sucursalesEmpleado));
};

/**
 * Capitaliza la primera letra de un string (función auxiliar para mostrar labels)
 * @param {string} str - String a capitalizar
 * @returns {string} - String con primera letra mayúscula
 */
export const capitalizarLabel = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
